import { Component } from '@angular/core';

import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';

import { NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-textarea',
  styleUrls: ['form-textarea.component.scss'],
  templateUrl: 'form-textarea.component.html',
  imports: [FormsModule, ReactiveFormsModule, FormFieldErrorComponent, NgClass],
})
export class FormTextareaComponent extends FieldBaseComponent {}
